import { useState } from "react";
import emailjs from "emailjs-com";

function Contact() {

    const [fullName, setFullName] = useState("");
    const [contact, setContact] = useState("");
    const [message, setMessage] = useState("");

    function handleSubmit(e: any) {
        e.preventDefault();
    
        emailjs.send("service_g8snmcq","template_cz805a6",{
            name: fullName,
            contact,
            message,
        }, "user_gBREhfn77piuhd9XrUZdH")
        .then(() =>{
            console.log("Success!")
        })

        setTimeout(() => {
            document.getElementById("submit")!.innerHTML = "Sent!";
            document.getElementById("submit")!.setAttribute("disabled", "true");
        }, 1000);
    }

    return <div id="contact" className="flex flex-col py-20 px-5 xl:px-36">
        <div className="flex pb-4 justify-evenly">
            <div className="hidden lg:block relative border-t border-black -bottom-5 ml-3 w-full max-w-xs">&nbsp;</div>
            <h1 className="text-2xl font-bold">CONTACT ME</h1>
            <div className="block relative border-t border-black -bottom-5 ml-3 w-full max-w-xs">&nbsp;</div>
        </div>
        <div className="flex flex-col justify-center items-center">
        <div className="flex gap-10 w-full justify-center">
            <iframe className="shadow rounded hidden xl:block" title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255281.19036276397!2d103.70416536508672!3d1.314339378152852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da11238a8b9375%3A0x887869cf52abf5c4!2sSingapore!5e0!3m2!1sen!2ssg!4v1644756169692!5m2!1sen!2ssg" width="600" height="450" style={{border:0}} allowFullScreen={false} loading="lazy"></iframe>
            <form className="flex flex-col gap-2 w-10/12 xl:w-1/2 justify-center" onSubmit={(e) => handleSubmit(e)}>
                <div className="flex flex-col xl:flex-row gap-2">
                    <label className="flex-1">
                        <span>Name</span>
                        <input className="w-full p-2 border border-gray-400 focus:outline-none focus:border-five focus:ring-1 focus:ring-five" value={fullName} onChange={(e) => setFullName(e.target.value)} placeholder="..." required/>
                    </label>
                    <label className="flex-1">
                        <span>Contact no.</span>
                        <input className="w-full p-2 border border-gray-400 focus:outline-none focus:border-five focus:ring-1 focus:ring-five" type="number" value={contact} onChange={(e) => setContact(e.target.value)} placeholder="+65"/>
                    </label>
                </div>
                <textarea className="border border-gray-400 focus:outline-none focus:border-five focus:ring-1 focus:ring-five p-2 h-80" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Message..." required/>
                <button id="submit" className="w-full p-2 bg-zinc-300 text-slate hover:bg-three transition" type="submit">Send</button>
            </form>
        </div>
        </div>
    </div>
}

export default Contact;